import React from 'react'
import './PaymentCard.scss';

export const PaymentCard = ({children, merchantData}) => {
    return (
        <div className="payment-card-component">
              <div className="payment-card-component__container">
                    <Header merchantData={merchantData}/>
                    <div className="payment-card-component__container--body">
                        {children}
                    </div>
              </div>
        </div>
    )
}

export default PaymentCard;


const Header = ({merchantData}) => {

    return (
        <div className="payment-card-header-component">
            <div className="payment-card-header-component__container">
                <div className="payment-card-header-component__container--logos">
                    {merchantData?.image && <img className="payment-card-header-component__container--logos-shield" src={require(`../../../../images/${merchantData?.image}`)} alt="save the children" /> }
                    <img className="payment-card-header-component__container--logos-ada-pay" src={require('../../../../images/adapay-logo-white.svg')} alt="ada pay" />
                </div>

                <div className="payment-card-header-component__container--title">
                    <h2>Payment to</h2>
                    <h3><b>{merchantData?.title}</b></h3>
                </div>
            </div>
        </div>
    )
}